import { CustomConverter, JsonObject, JsonProperty } from 'json-ts-mapper';
import { DateTimeConverter } from './converters/datesConverters';
import { UniteCoursMarche } from './unite-cours-marche';

@JsonObject

export class ValeurCoursMarche {
  constructor (
    valeur?: string,
    datePublication?: string
  ) {
    this.valeur = valeur as any;
    this.datePublication = datePublication as any;
  }

  @JsonProperty(Number)
  valeur?: number;

  @JsonProperty(String)
  @CustomConverter(DateTimeConverter)
  datePublication?: Date;
}
